/**
 * @generated SignedSource<<937d2cef91147b649b09ba9515368b87>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "acceptingNewPatients"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectiveFrom"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectiveTo"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "facilityId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "legalContractLineOfServiceId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "locationId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "providesHomeVisits"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "providesOfficeVisits"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "providesTelehealth"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "showInDirectory"
},
v10 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "FacilityLocationMutationGroup",
    "kind": "LinkedField",
    "name": "facilityLocation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "acceptingNewPatients",
                "variableName": "acceptingNewPatients"
              },
              {
                "kind": "Variable",
                "name": "effectiveFrom",
                "variableName": "effectiveFrom"
              },
              {
                "kind": "Variable",
                "name": "effectiveTo",
                "variableName": "effectiveTo"
              },
              {
                "kind": "Variable",
                "name": "facilityId",
                "variableName": "facilityId"
              },
              {
                "kind": "Variable",
                "name": "legalContractLineOfServiceId",
                "variableName": "legalContractLineOfServiceId"
              },
              {
                "kind": "Variable",
                "name": "locationId",
                "variableName": "locationId"
              },
              {
                "kind": "Variable",
                "name": "providesHomeVisits",
                "variableName": "providesHomeVisits"
              },
              {
                "kind": "Variable",
                "name": "providesOfficeVisits",
                "variableName": "providesOfficeVisits"
              },
              {
                "kind": "Variable",
                "name": "providesTelehealth",
                "variableName": "providesTelehealth"
              },
              {
                "kind": "Variable",
                "name": "showInDirectory",
                "variableName": "showInDirectory"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "FacilityLocationModifyPayload",
        "kind": "LinkedField",
        "name": "create",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FacilityLocation",
            "kind": "LinkedField",
            "name": "facilityLocation",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "NewLocationFacilityModalMutation",
    "selections": (v10/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v5/*: any*/),
      (v9/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v8/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "NewLocationFacilityModalMutation",
    "selections": (v10/*: any*/)
  },
  "params": {
    "cacheID": "f296aa45dc9ee5a6cd0a0747124d1fb2",
    "id": null,
    "metadata": {},
    "name": "NewLocationFacilityModalMutation",
    "operationKind": "mutation",
    "text": "mutation NewLocationFacilityModalMutation(\n  $facilityId: ID!\n  $locationId: ID!\n  $showInDirectory: Boolean!\n  $legalContractLineOfServiceId: ID!\n  $acceptingNewPatients: YesNoUnknown!\n  $providesTelehealth: YesNoUnknown!\n  $providesOfficeVisits: YesNoUnknown!\n  $providesHomeVisits: YesNoUnknown!\n  $effectiveFrom: DateOnly!\n  $effectiveTo: DateOnly!\n) {\n  facilityLocation {\n    create(input: {facilityId: $facilityId, locationId: $locationId, showInDirectory: $showInDirectory, legalContractLineOfServiceId: $legalContractLineOfServiceId, acceptingNewPatients: $acceptingNewPatients, providesTelehealth: $providesTelehealth, providesOfficeVisits: $providesOfficeVisits, providesHomeVisits: $providesHomeVisits, effectiveFrom: $effectiveFrom, effectiveTo: $effectiveTo}) {\n      facilityLocation {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "0d47c741d0875efff787f025fd87314a";

export default node;
